/**
 * Estrazione del solo testo da un frammento HTML, usata per verificare che la
 * formattazione automatica non abbia riscritto l'articolo: il modello puo'
 * aggiungere tag quanto vuole, ma le parole devono restare quelle inviate.
 */

const ENTITA: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  laquo: '<<',
  raquo: '>>',
};

/** Apostrofi, virgolette e trattini tipografici ricondotti alla forma semplice. */
function normalizzaTipografia(testo: string): string {
  return testo
    .replace(/[‘’‚‛′]/g, "'")
    .replace(/[“”„‟″]/g, '"')
    .replace(/[‐-―−]/g, '-')
    .replace(/…/g, '...')
    .replace(/ /g, ' ');
}

function decodificaEntita(testo: string): string {
  return testo
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCodePoint(parseInt(hex, 16)))
    .replace(/&#(\d+);/g, (_, dec) => String.fromCodePoint(parseInt(dec, 10)))
    .replace(/&([a-z]+);/gi, (intera, nome) => ENTITA[nome.toLowerCase()] ?? intera);
}

/**
 * Testo leggibile contenuto nell'HTML: tag via, entita' decodificate, spazi
 * collassati. Ogni tag diventa uno spazio, altrimenti `<p>a</p><p>b</p>`
 * risulterebbe "ab".
 */
export function testoNudo(html: string): string {
  if (!html) {
    return '';
  }
  const senzaTag = html.replace(/<[^>]*>/g, ' ');
  return normalizzaTipografia(decodificaEntita(senzaTag)).replace(/\s+/g, ' ').trim();
}

/**
 * Vero se i due frammenti contengono le stesse parole. Gli spazi sono ignorati
 * del tutto: spezzare "energia.La" in due paragrafi aggiunge uno spazio ed e'
 * formattazione legittima, mentre cambiare, togliere o aggiungere parole no.
 */
export function stessaSostanza(originale: string, formattato: string): boolean {
  return testoNudo(originale).replace(/\s+/g, '') === testoNudo(formattato).replace(/\s+/g, '');
}
